import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { renderColumnType, shortenandHoverString } from '../helper';

export default function SourceValues(props) {
  const { rowIndex, colIndex, relation, gridIndex, pageIndex } = props;
  return (
    <FormGroup className="flex-fill position-relative mb-0" key={`tableSourced_${pageIndex}_${gridIndex}_${rowIndex}_${colIndex}`}>
      <div>
        <div className="align-items-center">{shortenandHoverString(renderColumnType(relation), 20)}</div>
      </div>
    </FormGroup>
  );
}
